import { Projectile } from '../../../domain/projectile.js';

function fireTurretShot(turret, target, activeProjectiles, createTurretShotMeshCallback, scene) {
  const pDomain = new Projectile({
    id: `turret-shot-${Date.now()}`,
    sourceEntity: turret,
    targetEntity: target,
    speed: 1600,
    damage: turret.ad
  });
  const pMesh = createTurretShotMeshCallback
    ? createTurretShotMeshCallback(turret.team)
    : null;
  if (pMesh) {
    pMesh.position.set(turret.x, 4.8, turret.z);
    if (scene) scene.add(pMesh);
  }
  activeProjectiles.push({ domain: pDomain, mesh: pMesh });
}

/**
 * Structure auto-attacks → turret projectiles; clears call-for-help buffer.
 * (Distinct from legacy 2D `turretAiSystem.updateTurretAi`.)
 */
export function updateTurretAttacks({
  allTurretsAlive = [],
  allDamageableTargets = [],
  recentDamageEvents = null,
  dt = 0,
  activeProjectiles = [],
  createTurretShotMeshCallback = null,
  scene = null
} = {}) {
  for (const turret of allTurretsAlive) {
    if (!turret.attackRange || turret.ad <= 0) continue;
    const target = turret.updateTurretAggro(allDamageableTargets, recentDamageEvents);
    if (!target || target.isDead) continue;
    const tAttackEvent = turret.updateAttackCycle(dt);
    if (tAttackEvent.fired) {
      fireTurretShot(turret, target, activeProjectiles, createTurretShotMeshCallback, scene);
    }
  }
  if (Array.isArray(recentDamageEvents)) {
    recentDamageEvents.length = 0;
  }
}
